module.exports = __webpack_public_path__ + "static/media/offline-icon.0b81352a.svg";